module.exports = __webpack_public_path__ + "media/images/countrysquared/sn-81586239282b584af6bd696db84adda5.svg";